import { get, post } from '@/services/http'
import { getUserToken } from '@/services/authService'
import DateUtil from '@/utils/DateUtil'
import { isEmpty } from '@/utils/StringUtil'

export function exportActiveRepairsXlsx(keyword, sort) {
  return get(`/api/v1/files/export/active-repairs/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportClosedRepairsXlsx(keyword, sort) {
  return get(`/api/v1/files/export/closed-repairs/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportActionRequiredRepairsXlsx(keyword, sort) {
  return get(`/api/v1/files/export/action-required-repairs/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      // TODO: inject this header in http.js
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportGeneralReportXlsx(data, sort) {
  return post(`/api/v1/files/export/general-report/xlsx?sort=${sort}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportUsersXlsx(keyword, sort) {
  return get(`/api/v1/files/export/users/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportPartsXlsx(keyword, sort) {
  return get(`/api/v1/files/export/parts/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportPartRequestXlsx(keyword, sort) {
  return get(`/api/v1/files/export/part-request/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRemoteSupportXlsx(keyword, sort) {
  return get(`/api/v1/files/export/remote-support/xlsx?sort=${sort}${!isEmpty(keyword) ? '&keyword=' + keyword : ''}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale-Offset': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRepairDetailTabXlsx(repairId) {
  return get(`/api/v1/files/export/repair-detail-tab/xlsx?repairId=${repairId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRepairDiagnosticsTabXlsx(repairId) {
  return get(`/api/v1/files/export/repair-diagnostics-tab/xlsx?repairId=${repairId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRepairApprovalTabXlsx(repairId) {
  return get(`/api/v1/files/export/repair-approval-tab/xlsx?repairId=${repairId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRepairTabXlsx(repairId) {
  return get(`/api/v1/files/export/repair-tab/xlsx?repairId=${repairId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportRepairHistoryTabXlsx(repairId) {
  return get(`/api/v1/files/export/repair-history-tab/xlsx?repairId=${repairId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportPartRequestDetailsTabXlsx(partRequestId) {
  return get(`/api/v1/files/export/part-request-detail-tab/xlsx?partRequestId=${partRequestId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}
export function exportPartRequestHistoryTabXlsx(partRequestId) {
  return get(`/api/v1/files/export/part-request-history-tab/xlsx?partRequestId=${partRequestId}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}

export function exportRemoteSupportHistoryTabXlsx(id) {
  return get(`/api/v1/files/export/remote-support-history-tab/xlsx?id=${id}`, {
    headers: {
      'Authorization': getUserToken(),
      'Locale': DateUtil.getTimeZoneInPureNumber(new Date())
    },
    responseType: 'blob'
  })
}